// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__YpEIq","readonlyFieldLabel":"styles_readonlyFieldLabel__Zh-oZ","boldError":"styles_boldError__9+UMB"};